import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

const SvgHome = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <G clipPath="url(#clip0)">
                <Path
                    fill={props.color ?? baseColors.green.primary}
                    d="M19.664 8.94L10.691.765a1.02 1.02 0 00-1.382 0L.336 8.941c-.316.287-.42.73-.266 1.128.154.398.53.655.957.655H2.46v8.193c0 .324.263.588.588.588h4.919a.588.588 0 00.588-.588v-4.974h2.89v4.974a.59.59 0 00.589.588h4.918a.588.588 0 00.588-.588v-8.193h1.434c.426 0 .802-.257.956-.655a1.02 1.02 0 00-.266-1.128zm-2.278-7.27h-3.95l4.538 4.126V2.257a.588.588 0 00-.588-.588z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0">
                    <Path fill="#fff" d="M0 0h20v20H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgHome
